import React from "react";
import type { AnalyticsChartType } from "store/analyticsStore";

import type { DataType } from "../utils";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import PieChart from "./PieChart";
import type { BarChartData, LineChartData, PieChartData } from "./utils";

interface IChart {
    /**
     * Type of Chart
     */
    type: AnalyticsChartType;
    /**
     * Type of data "turnover" | "quantities"
     */
    dataType: DataType;
    /**
     * Data for Chart
     */
    dataChart: LineChartData | PieChartData | BarChartData;
}
/**
 * Render an Analytics Sales Chart based on type
 */
const Chart = ({ type, dataType, dataChart }: IChart) => {
    switch (type) {
        case "line-chart":
            return <LineChart data={dataChart as LineChartData} dataType={dataType} />;
        case "pie-chart-per-channel":
            return <PieChart data={dataChart as PieChartData} dataType={dataType} />;
        case "pie-chart-per-country":
            return <PieChart data={dataChart as PieChartData} dataType={dataType} />;
        case "bar-chart":
            return <BarChart data={dataChart as BarChartData} dataType={dataType} />;
        default:
            return <></>;
    }
};

export default React.memo(Chart);
